import HeaderFooterControlsBar from './HeaderFooterControlsBar';

export default HeaderFooterControlsBar;
